import React from "react";

const EmptyCard = ({ icon, emptyStateText, modifySearchText }) => {
  return (
    <div className="bg-solid-white text-center rounded pb-20">
      <div className="pt-24 pb-16">{icon}</div>
      <div className="space-y-4">
        <span className="font-semibold text-gray-text text-h5">
          {emptyStateText}
        </span>
        <span className="block font-mulish text-gray-dark text-hl-2">
          {modifySearchText}
        </span>
      </div>
    </div>
  );
};

export default EmptyCard;
